<div [ngClass]="this.menuService.menuOptions['export'] ? 'active' : ''" class="export-menu">
  <div>
    <h1>Export</h1>
    <ul>
      <app-menu-option
        [action]="this.exportMapToImage.bind(this)"
        [label]="'Export Map to Image'">
      </app-menu-option>
      <app-menu-option
        [action]="this.printMap.bind(this)"
        [label]="'Print Map'">
      </app-menu-option>
      <ng-container *ngIf="gritUserService.allowedRoles(GritUserRoleGroup.FullUser, GritUserRoleGroup.ApprovingEntity)">

        <app-menu-option *editable
          [action]="this.exportService.showMesssageModal.bind(exportService, 'NavAids', this.navaidsOptions)"
          [labelOnMenu]="'NavAids'"
          [label]="'Export NavAids'">
        </app-menu-option>

      <app-menu-option *editable
        [action]="this.exportService.showMesssageModal.bind(exportService, 'Coordinate Points', this.coordPointsOptions)"
        [labelOnMenu]="'Coordinate Points'"
        [label]="'Export Coordinate Points'">
      </app-menu-option>

      <app-menu-option *ngIf="gritUserService.allowedRoles(GritUserRoleGroup.FullUser, GritUserRoleGroup.ApprovingEntity)"
        [action]="this.exportService.showMesssageModal.bind(exportService, 'RFI-Transmitters', this.deviceOptions)"
        [labelOnMenu]="'RFI-Transmitters'"
        [label]="'Export RFI-Transmitters'">
      </app-menu-option>

      <app-menu-option *ngIf="gritUserService.allowedRoles(GritUserRoleGroup.FullUser, GritUserRoleGroup.ApprovingEntity)"
        [action]="this.exportService.showMesssageModal.bind(exportService, 'Map RFI-Transmitters', this.interferenceTestDeviceOptions)"
        [labelOnMenu]="'Map RFI-Transmitters'"
        [label]="'Export Map RFI-Transmitters'">
      </app-menu-option>
      <app-menu-option *ngIf="gritUserService.allowedRoles(GritUserRoleGroup.FullUser, GritUserRoleGroup.ApprovingEntity)"
        [action]="this.exportService.showMesssageModal.bind(exportService, 'Receivers', this.receiverOptions)"
        [labelOnMenu]="'Receivers'"
        [label]="'Export Receivers'">
      </app-menu-option>

      </ng-container>
<!--      <app-menu-option
        [action]="this.exportService.showMesssageModal.bind(exportService, 'Procedures', this.proceduresOptions)"
        [labelOnMenu]="'Procedures'"
        [label]="'Export Procedures'">
      </app-menu-option>
      &lt;!&ndash;<app-menu-option>Layer</app-menu-option>&ndash;&gt;
      <app-menu-option
        [action]="this.exportService.showMesssageModal.bind(exportService, 'AirSpace Boundaries', this.airSpaceBoundariesOptions)"
        [labelOnMenu]="'AirSpace Boundaries'"
        [label]="'Export AirSpace Boundaries'">
      </app-menu-option>-->
    </ul>
  </div>
</div>
